import PropTypes from 'prop-types';
import { augmentClassName } from '../../../../../utils/GlobalCssProxy';
import Button from 'react-bootstrap/Button';
import ModalBasic from '../../../../atoms/modal-basic';
import TableBasic from '../../../../atoms/table-basic';

const className = augmentClassName();

const MultipleDocuments = ({ modalValues, onHide, show }) => {
  return (
    <ModalBasic show={show} onHide={onHide} modalSm={true}>
      <ModalBasic.Header>
        <ModalBasic.Title>
          <ModalBasic.Subtitle>{'Fact Sheets'}</ModalBasic.Subtitle>
        </ModalBasic.Title>
        <ModalBasic.CloseButton onClick={onHide} />
      </ModalBasic.Header>
      <ModalBasic.Body>
        <TableBasic {...className('fact-sheet-table')}>
          <tbody>
            {modalValues.map((value, index) => {
              return (
                <tr
                  data-key={`${value.planName || ''}-${index}`}
                  key={`${value.planName || ''}-${index}`}
                >
                  <td>
                    <a
                      href={value.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      {...className('fact-sheet-link', 'text-black')}
                    >
                      {value.planName}
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </TableBasic>
      </ModalBasic.Body>
    </ModalBasic>
  );
};

MultipleDocuments.propTypes = {
  modalValues: PropTypes.array,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool
};

const LeavingSite = ({ externalSiteClick, onHide, show }) => {
  return (
    <ModalBasic modalSm={true} modalNoColor={true} show={show} onHide={onHide}>
      <ModalBasic.Header>
        <ModalBasic.Title>
          <ModalBasic.Subtitle>{'Leaving this page?'}</ModalBasic.Subtitle>
        </ModalBasic.Title>
        <ModalBasic.CloseButton onClick={onHide} />
      </ModalBasic.Header>
      <ModalBasic.Body>
        {
          "You are about to leave TIAA's website and access a website that is unaffiliated with TIAA. TIAA does not assume responsibility or liability for the content or privacy policies of external sites."
        }
      </ModalBasic.Body>
      <div {...className('d-inline-flex', 'justify-content-between', 'w-48', 'button-container')}>
        <Button
          variant={'outline-black'}
          {...className(
            'btn--rounded',
            'font-weight-bold',
            'text-uppercase',
            'font-family-sans-serif'
          )}
          size="sm"
          role="button"
          onClick={onHide}
        >
          Cancel
        </Button>
        <Button
          variant={'outline-black'}
          {...className(
            'btn--rounded',
            'font-weight-bold',
            'text-uppercase',
            'font-family-sans-serif',
            'button-width'
          )}
          size="sm"
          role="button"
          onClick={externalSiteClick}
        >
          OK
        </Button>
      </div>
    </ModalBasic>
  );
};

LeavingSite.propTypes = {
  externalSiteClick: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool
};

const modalDocuments = { MultipleDocuments, LeavingSite };

export default modalDocuments;
